module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp1_9016.191f6c22.png";